import React from 'react';
import Navbar from './components/Navbar';
import AreasStrip from './components/AreasStrip';
import Hero from './components/Hero';
import About from './components/About';
import StatsBar from './components/StatsBar';
import Services from './components/Services';
import Areas from './components/Areas';
import Gallery from './components/Gallery';
import Reviews from './components/Reviews';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppBtn from './components/WhatsAppBtn';

export default function App() {
  return (
    <>
      <Navbar />
      <AreasStrip />
      <Hero />
      <About />
      <StatsBar />
      <Services />
      <Areas />
      <Gallery />
      <Reviews />
      <Contact />
      <Footer />
      <WhatsAppBtn />
    </>
  );
}
